import api from '../../utils/api';

export const removeComponent = (id: number) =>
  api.delete({
    url: `/component/${id}`,
  });
